
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
NProgress.configure({ showSpinner: false });
import router from '@/router';
import { routes } from '@/router';

const IsRouteExists = (path, allRoutersList) => {
  for (let route of allRoutersList) {
    const routePattern = route.path.replace(/:(\w+)\?/g, '?([^/]*)').replace(/:\w+/g, '([^/]+)');
    const regex = new RegExp(`^${routePattern}$`);
    if (regex.test(path)) {
      return true;
    }
  }
  return false;
};

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (!IsRouteExists(to.path, routes)) {
      next({
        path: '/404',
        replace: true
      });
      NProgress.done();
    } else {
      next();
      NProgress.done();
    }
});
